import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
// import './registerServiceWorker'

if('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    registrations.forEach(function(v) { v.unregister() })
  })
}

import * as VueGoogleMaps from 'vue2-google-maps'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDza7glg24kZ4Xj7cWUQMq1rR9Uw6mLk1k",
    libraries: "places"
  }
})

Vue.use(VueAwesomeSwiper)

let pageTO

router.beforeEach((to, from, next) => {
  if(!to || !from || to.path !== from.path) {
    clearTimeout(pageTO)
    store.commit('setPageLoading', true)
    pageTO = setTimeout(() => next(), 160)
    if(typeof window.ga === 'function') {
      window.ga('set', 'page', to.path)
      window.ga('send', 'pageview')
    }
  }
  else {
    next()
  }
})

Vue.mixin({
  methods: {
    preloadImages(urls = []) {
      return Promise.all(urls.map(url => this.loadImage(url)))
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve()
        img.onerror = () => reject()
        img.src = url
      })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
